module.exports = __webpack_public_path__ + "media/site_templates/www.joiners.net.au/images/our_services_3-0e9f1de911dc83ef1084d11780cfd6f1.jpg";